import processOrderRequest, {DOC_ACTION_COMPLETE} from "../requests/processOrderRequest";

const completeOrderAction = async (session, get) => {

    const resp = await processOrderRequest(session, get().orderID, DOC_ACTION_COMPLETE);
    if(!resp.ok) throw resp.value;

    const completedOrder = { ...get().order };
    completedOrder.products = get().products;
    completedOrder.charges = get().charges;

    return { orderID: 0, order: undefined, products: undefined, charges: undefined, completedOrder, input: undefined };
}

export default completeOrderAction;